module.exports = __webpack_public_path__ + "images/pages/resources/patient-brochure.png";